import axios from "axios";
import React, { useEffect, useState } from "react";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;
const Checkbox = ({ children, ...props }) => (
  <label className="mr-4 text-sm italic text-gray-600">
    <input type="checkbox" className="mr-1" {...props} />
    {children}
  </label>
);

export default function ManagerSelect({ userType, userId }) {
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [isClearable, setIsClearable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  // Fetch options from API
  useEffect(() => {
    const fetchOptions = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `${base_url}/${api_type}/relationshipManagerList`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
            },
          }
        ); // <-- Replace with your API
        setOptions(response?.data?.data?.list);
        console.log("response", response);
      } catch (error) {
        console.error("Failed to fetch options:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchOptions();
  }, []);

  const filteredOptions = options.filter((option) =>
    option.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = async (option) => {
    setSelectedOption(option);
    setIsDropdownOpen(false);
    setSearch("");

    try {
      await axios.post(
        `${base_url}/${api_type}/relationshipManager/setUser`,
        {
          userId: userId,
          managerId: option?.id,
          userType: userType, // investor or partner
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
          },
        }
      );
      console.log("Selected option sent:", option.value);
    } catch (error) {
      console.error("Error sending selected option:", error);
    }
  };

  const handleClear = async (selectedOption) => {
    setSelectedOption(null);
    setSearch("");

    try {
      await axios.post(
        `${base_url}/${api_type}/relationshipManager/removeUser`,
        {
          userId: userId,
          managerId: selectedOption?.id,
          userType: userType, // investor or partner
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
          },
        }
      );
      console.log("Selection cleared");
    } catch (error) {
      console.error("Error clearing selection:", error);
    }
  };

  return (
    <div className="w-full text-left relative">
      {/* Select input */}
      <div
        className="relative border px-3 py-2 rounded cursor-pointer bg-white"
        onClick={() => setIsDropdownOpen((open) => !open)}
      >
        <input
          className="w-full outline-none"
          placeholder="Select a manager"
          value={selectedOption ? selectedOption.name : search}
          onChange={(e) => {
            setSearch(e.target.value);
            setSelectedOption(null);
            setIsDropdownOpen(true);
          }}
        />

        {/* Clear button */}
        {selectedOption && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleClear(selectedOption);
            }}
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
          >
            ×
          </button>
        )}
      </div>

      {/* Dropdown options */}
      {isDropdownOpen && (
        <div className="border mt-1 rounded shadow-md bg-white max-h-40 overflow-y-auto absolute w-full z-10">
          {isLoading ? (
            <div className="p-2 text-center text-gray-400">Loading...</div>
          ) : filteredOptions.length === 0 ? (
            <div className="p-2 text-gray-500">No options</div>
          ) : (
            filteredOptions.map((option) => (
              <div
                key={option.id}
                className="p-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSelect(option)}
              >
                {option.name}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
